import { config } from '@/config'

export default function(dom, opts) {
	let options = {
		"autoplay": true,
		"hideSel": "img",
		"minBreakpoint": null,
		...opts
	}

	init()

	function init() {
		if (options.minBreakpoint == null || isWindowLargerThanBreakpoint(options.minBreakpoint)) {
			const el = document.createElement("div")
			const tmpl = dom.firstElementChild.innerHTML
			el.innerHTML = tmpl
			dom.append(el)
			const video = el.querySelector("video")
			if (options.autoplay) {
				video.setAttribute("autoplay", true)
				video.setAttribute("muted", true)
			}

			//autoplay
			Promise.race([
				canplay(video, 3000),
				timeout(10000)
			]).then(function(){
				video.style.display = "block"
				if (options.hideSel) {
					const hideEl = dom.querySelector(options.hideSel)
					if (hideEl) {
						hideEl.style.display = "none"
					}
				}
				if (options.autoplay) {
					let prom = video.play()
					//this may be a promise and we can catch it
					if (prom) {
						prom.catch((ex) => {
							//silent fail autoplay video
						})
					}
				}
			})
		}
	}

	function canplay(video, wait) {
		return new Promise(function(resolve, reject) {
			var waited = false
			var canplay = false

			video.addEventListener("canplaythrough", () => {
				canplay = true
				if (waited) resolve()
			})

			setTimeout(() => {
				waited = true
				if (canplay) resolve()
			}, wait)
		})
	}

	function timeout(ms) {
		return new Promise(function(resolve,reject) {
			setTimeout(resolve, ms, "timeout");
		});
	}

	function isWindowLargerThanBreakpoint(bp) {
		var w = window,
			d = document,
			e = d.documentElement,
			g = d.getElementsByTagName('body')[0],
			x = w.innerWidth || e.clientWidth || g.clientWidth;

		if (typeof bp == "string" && config.responsive[bp] != null) {
			bp = config.responsive[bp]
		}
		return x > bp
	}
}
